<!-- Screenname:Store Master  Creation
Developer Name:Tharuni.
Created date on:1/02/2023
Last Working date on:
Comments and Suggestions:
TS File:StoreService -->
<template>
  <div class="overall-bg">
    <b-container>
      <b-row>
        <b-col>
          <BacktoPage path="/StoreMaster"></BacktoPage>
          <Headerlayout :headertext="storeId
            ? $t('stores.StoreMaster.EditFormHeader')
            : $t('stores.StoreMaster.FormHeader')
            " :contenttext="$t('stores.StoreMaster.FormHeaderContent')" class="mb-0">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="form-white-bg my-3 p-1">
        <b-row>
          <b-col class="pt-2" lg="12" md="12" sm="12" cols="12">
            <h6 class="ms-3 light-txt">STORE TYPE</h6>
          </b-col>
          <b-row> </b-row>
          <b-tabs class="btstabs" v-model="tabIndex" pills card>
            <b-tab v-for="(tab, index) in menuarray" :key="index" :title="tab.SubMenuName" :disabled="tab.disabled"
              @click="TabClick(tab)">
              <component :is="tab.FixedHref" :MainStoreRights="functionRights" :SubStoreRights="functionRights"
                :DepartmentStoreRights="functionRights" v-if="tab.tabRights" />
              <p v-else>You Don't have access to this page</p>
            </b-tab>
            <!-- <b-tab title="Main Store" :disabled="isDisable.mainStore">
              <MainTab></MainTab>
            </b-tab>
            <b-tab title="Sub Store" :disabled="isDisable.subStore">
              <Subtab></Subtab>
            </b-tab>
            <b-tab title="Department Store" :disabled="isDisable.deptStore">
              <Deptab></Deptab>
            </b-tab> -->
          </b-tabs>
        </b-row>
      </b-row>
    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import MainTab from "../StoreMaster/StoreTab/mainstore.vue";
import Subtab from "../../../Masters/Stores/StoreMaster/StoreTab/substore.vue";
import Deptab from "../../../Masters/Stores/StoreMaster/StoreTab/depstore.vue";
import StoreMaster from "../StoreMaster/StoreMaster";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import MastersService from "../../../../../../modules/Inventory/Service/MastersService";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    MainTab,
    Subtab,
    Deptab,
    BacktoPage,
    Headerlayout,
  },
  // props: {

  // }
  setup() {
    debugger;

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    const router = useRoute();

    const tabIndex = ref(0);
    const toast = useToast();

    let menuarray: any = ref([]);
    let menuList: any = ref([]);

    const isDisable = ref({
      mainStore: false,
      subStore: false,
      deptStore: false,
    });
    const storeId = router.query.storeId;
    const storeType = router.query.storeType;
    if (storeType == "1") {
      (tabIndex.value = 0),
        (isDisable.value.subStore = true),
        (isDisable.value.deptStore = true);
    } else if (storeType == "2") {
      tabIndex.value = 1;
      (isDisable.value.mainStore = true), (isDisable.value.deptStore = true);
    } else if (storeType == "3") {
      tabIndex.value = 2;
      (isDisable.value.mainStore = true), (isDisable.value.subStore = true);
    }
    console.log(router.query);

    onMounted(() => {
      debugger;
      LoadMenus();
    });

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(
        4,
        rolesData.RoleId,
        usersData.OrganizationId
      );

      console.log("MenuListMasterInventory", response["result"]);

      menuList.value = response["result"];
      let count = 0;
      menuList.value = menuList.value.map((i1) => {
        if (storeId) {
          if (i1.StoreRights == storeType) {
            tabIndex.value = count;
            i1.disabled = false;
          } else {
            i1.disabled = true;
          }
        } else {
          i1.disabled = false;
          tabIndex.value = 0;
        }
        count = count + 1;
        return i1;
      });

      if (menuList.value.length > 0) {
        TabClick(menuList.value[tabIndex.value]);
      }
    }

    let functionRights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    async function TabClick(SubMenuDetails) {
      debugger;

      console.log("SubMenuEntityId", SubMenuDetails.EntityId);

      let InstantEntityId = {
        EntityId: SubMenuDetails.EntityId,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      const response = await MastersService.CheckMenuRights(
        InstantEntityId.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      let Rights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
        CreateId: 0,
        UpdateId: 0,
        ReadId: 0,
        DeleteId: 0,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          Rights.value.Create = operation.IsActive;
          Rights.value.CreateId = operation.OperationID;
        } else if (operation.OperationName === "Update") {
          Rights.value.Update = operation.IsActive;
          Rights.value.UpdateId = operation.OperationID;
        } else if (operation.OperationName === "Read") {
          Rights.value.Read = operation.IsActive;
          Rights.value.ReadId = operation.OperationID;
        } else if (operation.OperationName === "Delete") {
          Rights.value.Delete = operation.IsActive;
          Rights.value.DeleteId = operation.OperationID;
        }
      }
      menuarray.value = menuList.value.map((i1) => {
        if (
          i1.EntityId == SubMenuDetails.EntityId &&
          Rights.value.Read == true &&
          Rights.value.Create == false
        ) {
          i1.tabRights = false;
        } else {
          i1.tabRights = true;
        }
        return i1;
      });

      functionRights.value.Create = Rights.value.Create;
      functionRights.value.Update = Rights.value.Update;
      functionRights.value.Read = Rights.value.Read;
      functionRights.value.Delete = Rights.value.Delete;
      functionRights.value.CreateId = Rights.value.CreateId;
      functionRights.value.UpdateId = Rights.value.UpdateId;
      functionRights.value.ReadId = Rights.value.ReadId;
      functionRights.value.DeleteId = Rights.value.DeleteId;
    }

    return {
      tabIndex,
      isDisable,
      menuarray,
      functionRights,
      TabClick,
      storeId,
    };
  },
});
</script>
